import React from 'react';
import { get } from 'lodash-es';
import { BUTTON_SIZE } from '@/config/ui/button';
import { POPUP_HEIGHT } from '@/config/ui/popup';
import { ForwardButton } from '../../component/atom/Button';
import ChoiceChip from '../../component/atom/ChoiceChip';
import Popup from '../../component/composite/Popup';
import { S } from '../util/style';
import { HOME_CARE_TITLE } from '../../config/option';
import { POPUP_TYPE } from '../../config/popup';
const renderPopupBody = ({ hospitalBedOptionList, handleChoiceChipClick, hospitalBed, }) => {
    const homeCareOption = hospitalBedOptionList.find((option) => get(option, 'displayTitle') === HOME_CARE_TITLE);
    const homeCareOptionValue = get(homeCareOption, 'displayTitle', '');
    const withoutHomeCareHospitalBedOptionList = hospitalBedOptionList.filter((option) => get(option, 'displayTitle', '') !== homeCareOptionValue);
    return (<S.PopupBody>
      <div>
        <S.PopupBodySection>
          <S.PopupBodyTitle>{homeCareOptionValue}</S.PopupBodyTitle>
          <S.PopupBodyLayoutGrid>
            <ChoiceChip key={homeCareOptionValue} isSelected={hospitalBed === homeCareOptionValue} content={homeCareOptionValue} onChipClick={() => handleChoiceChipClick({ optionValue: homeCareOptionValue })}/>
          </S.PopupBodyLayoutGrid>
        </S.PopupBodySection>
        <S.PopupSectionGap />
        <S.PopupBodySection>
          <S.PopupBodyTitle>醫院床位</S.PopupBodyTitle>
          <S.PopupBodyLayoutGrid>
            {withoutHomeCareHospitalBedOptionList.map((hospitalBedOption) => {
            const optionValue = get(hospitalBedOption, 'displayTitle', '');
            return (<ChoiceChip key={optionValue} isSelected={hospitalBed === optionValue} content={optionValue} onChipClick={() => handleChoiceChipClick({ optionValue })}/>);
        })}
          </S.PopupBodyLayoutGrid>
        </S.PopupBodySection>
        <S.PopupBodyNotes>＊若您不確定病床種類，請與醫院聯絡確認後再進行派案唷！</S.PopupBodyNotes>
      </div>
    </S.PopupBody>);
};
const renderPopupFooter = ({ isForwardButtonAvailable, handleForwardButtonClick, }) => (<S.PopupFooterWithoutNotes>
    <ForwardButton onButtonClick={handleForwardButtonClick} isAvailable={isForwardButtonAvailable} size={BUTTON_SIZE.MEDIUM}>
      確定
    </ForwardButton>
  </S.PopupFooterWithoutNotes>);
export default function View({ 
// data
popupType, hospitalBedOptionList, hospitalBed, isForwardButtonAvailable, 
// func
setPopupType, handleChoiceChipClick, handleForwardButtonClick, }) {
    return (<Popup isSlideIn={popupType === POPUP_TYPE.HOSPITAL_BED} closePopup={() => setPopupType(POPUP_TYPE.CLOSE)} height={POPUP_HEIGHT.LARGE} title='床位種類' popupBody={renderPopupBody({ hospitalBedOptionList, handleChoiceChipClick, hospitalBed })} popupFooter={renderPopupFooter({ isForwardButtonAvailable, handleForwardButtonClick })}/>);
}
